/**
 * @file Последние успешные данные для локальной проверки перед передачей.
 *
 * Наполняются обычным чтением папки и периодическим чтением квоты.
 * Это снимок, а не резервирование трафика или гарантия отсутствия нового файла.
 */
import { availableTraffic } from '../traffic/quota.ts'
import type { TrafficQuota } from '../traffic/quota.ts'

// Снимки живут в текущей сессии и наполняются обычными чтениями страницы.
// Передачи сами их не обновляют; окончательное решение о квоте принимает сервер.
const quotas = new Map<string, TrafficQuota>()
const folders = new Map<string, ReadonlySet<string>>()
const folderKey = (boxId: string, path: string) =>
    JSON.stringify([boxId, path.replace(/\/$/, '')])

export function rememberQuota(boxId: string, quota: TrafficQuota) {
    quotas.set(boxId, { ...quota })
}

export function cachedAvailableTraffic(boxId: string): number | null {
    const quota = quotas.get(boxId)

    return quota ? availableTraffic(quota) : null
}

export function rememberFolder(
    boxId: string,
    path: string,
    names: Iterable<string>,
) {
    folders.set(folderKey(boxId, path), new Set(names))
}

export function cachedFolderNames(
    boxId: string,
    path: string,
): ReadonlySet<string> | null {
    return folders.get(folderKey(boxId, path)) ?? null
}

export function clearTransferSnapshots() {
    quotas.clear()
    folders.clear()
}
